import Vue from 'vue'
import Vuex from 'vuex'
import { Message } from 'element-ui'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { login, getUserInfo } from '@/api/user'

Vue.use(Vuex)

const LanguageKey = 'adminLanguageMode'

function initLanguageMode(userData) {
  const cachedLanguage = localStorage.getItem(LanguageKey)
  if (!cachedLanguage) {
    localStorage.setItem(LanguageKey, Number(userData?.isForeign) === 1 ? 'en' : 'zh')
  }
}

export default new Vuex.Store({
  state: {
    token: getToken(),
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    sidebar: {
      opened: true
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    TOGGLE_SIDEBAR(state) {
      state.sidebar.opened = !state.sidebar.opened
    }
  },
  actions: {
    // 登录
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response && (response.code === 200 || response.code === 0)) {
            const { token, userId, username, role, shopId, shopName } = response.data
            const userData = {
              id: userId,
              userId,
              username,
              role,
              shopId,
              shopName
            }
            commit('SET_TOKEN', token)
            commit('SET_USER_INFO', userData)
            setToken(token)
            localStorage.setItem('userInfo', JSON.stringify(userData))
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject({ msg: '登录过程中出现错误，请稍后重试' })
        })
      })
    },
    // 获取用户信息
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          if (response.code === 200) {
            commit('SET_USER_INFO', response.data)
            localStorage.setItem('userInfo', JSON.stringify(response.data))
            initLanguageMode(response.data)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出登录
    logout({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', {})
        removeToken()
        localStorage.removeItem('userInfo')
        resolve()
      })
    }
  }
})
